<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <h6 class="heading-small text-muted m-0">ข้อมูลบัญชีธนาคาร</h6> 
        </div>
        <div>
            <b-button variant="primary" @click="openPromptPay()">
                <i class="fas fa-plus"></i> เพิ่มบัญชีพร้อมเพย์
            </b-button>
            <b-button variant="primary" @click="OpenModal('BankDetail')">
                <div class="d-flex justify-content-center align-items-center">
                    <i class="fas fa-plus"></i>
                    <span class="ml-2">
                        เพิ่มบัญชีธนาคาร
                    </span>
                </div>
            </b-button>
        </div>
    </div>
    <div class="mt-5">
        <div class="d-flex align-items-center justify-content-center mt-2">
            <div class="col-7">
                <p class="m-auto pl-5">บัญชี</p>
            </div>
            <div class="col-5 text-center justify-content-center">
                <p class="m-auto">การจัดการ</p>
            </div>
        </div>
        <div v-if="shopBank.length < 1">
            <p class="text-muted m-0 mt-4 text-center">ยังไม่มีบัญชีธนาคาร</p>
        </div>
        <template v-else>
            <div v-for="infoBank in shopBank" :key="infoBank.id" class="d-flex align-items-center mt-2 background-color-bank">
                <div class="col-7">
                    <div class="row align-items-center">
                        <div class="col-2">
                            <img 
                                :src="formatBankImage(infoBank.account_bank)"
                                width="45" 
                                height="45" 
                                alt="logoBank"
                            >
                        </div>
                        <div class="col-10 py-3">
                            <p class="m-0">
                                {{ formatBankName(infoBank.account_bank) }}
                            </p>
                            <p class="m-0">
                                {{ infoBank.account_bank === '999' ? infoBank.account_id : formatNum(infoBank.account_id) }}
                            </p>
                            <p class="m-0">
                                {{ infoBank.name }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <div class="mx-3">
                            <i class="fas fa-pen icon-primary cursor-pointer" @click="editBanking(infoBank)"></i>
                        </div>
                        <div class="mx-3">
                            <i class="fas fa-trash-alt icon-danger cursor-pointer" @click="deletedShopBank(infoBank.id)"></i>
                        </div>
                        <div>
                        <hr class="hr-vertical"/>
                        </div>
                        <div class="mx-3">
                            <b-form-checkbox v-model="infoBank.status" @input="isChangeValue($event, infoBank.id)" switch>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <ModalPromptPay 
        :modalPromptPay="modalPromptPay"
        @emitReloadShopBank="$emit('emitReloadShopBank')"
    />
  </div>
</template>

<script>
import { formatNumberBank } from "@/helpers/util.js"
import formatBank from "@/plugins/formatBank"
import ModalPromptPay from "../../Modals/ModalPromptPay.vue"

export default {
    props: {
        modalShop: Object,
        shopBank: Array,
        modalPromptPay: Object
    },
    methods: {
        isChangeValue($event, Id) {
            const headers = {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            };
            const bodyAssign = {
                status: $event ? "OPEN" : "CLOSED"
            };
            this.$http.post(this.$API_URL + `/shop/bank/updatestatus/${Id}`, bodyAssign, headers);
        },
        deletedShopBank(getId) {
            return this.$emit("deletedShopBank", getId);
        },
        formatBankImage(keyCode) {
            let bank = formatBank.find(res => res.code === keyCode);
            if(!bank){
                return require('@/assets/images/banking/promptpay.png');
            }
            return "../../../" + bank.image;
        },
        formatBankName(keyCode) {
            let bankName = formatBank.find(res => res.code === keyCode);
            if(!bankName){
                return ''
            }
            return bankName.name;
        },
        formatNum(num) {
            return formatNumberBank(num);
        },
        openPromptPay(){
            this.modalPromptPay.show = true
            this.modalPromptPay.type = 'CREATE'
        },
        OpenModal(key) {
            this.modalShop[key] = !this.modalShop[key];
            if (key == "BankDetail") {
                this.modalShop.textHeader = "เพิ่มช่องทางการชำระเงิน";
                this.modalShop.type = "adding";
            }
        },
        editBanking(infoBank) {
            if( infoBank.account_bank === '999' ){
                this.modalPromptPay.show = true;
                this.modalPromptPay.number = infoBank.account_id
                this.modalPromptPay.type = 'EDIT'
                this.modalPromptPay.id = infoBank.id
            }else{
                this.modalShop.textHeader = "แก้ไขช่องทางการชำระเงิน";
                this.modalShop.BankDetail = true;
                this.modalShop.type = "editing";
                return this.$emit("editBankUser", infoBank.id);
            }
        }
    },
    components: { ModalPromptPay }
}
</script>